import { Cell, Grid, Heading } from 'bold-ui'
import { RadioGroupField } from 'components/form'

import { MamografiaPerguntaField } from '../model-mamografia'
import { MamografiaIndicacaoClinicaAccordion } from './MamografiaIndicacaoClinicaAccordion'
import { MamografiaIndicacaoClinicaMamaAccordion } from './MamografiaIndicacaoClinicaMamaAccordion'
import { MamografiaRastreamentoRadioGroupField } from './MamografiaRastreamentoRadioGroupField'
import {
  avaliacaoRespostaQuimioterapiaOptions,
  controleRadioAccordionOptions,
  lesaoBenignaAccordionOptions,
  lesaoCancerAccordionOptions,
  revisaoMamografiaLesaoAccordionOptions,
  tipoMamografiaOptions,
} from './model-indicacaoClinica'

export function MamografiaIndicacaoClinicaModalStep() {
  return (
    <Grid>
      <Cell size={12}>
        <RadioGroupField
          name={MamografiaPerguntaField.tipoMamografia}
          label='Tipo de mamografia'
          options={tipoMamografiaOptions}
          required
        />
      </Cell>
      <Cell size={12}>
        <MamografiaRastreamentoRadioGroupField />
      </Cell>
      <Cell size={12}>
        <Heading level={3} color='normal' fontWeight='bold'>
          Mamografia diagnóstica
        </Heading>
      </Cell>
      <Cell size={12}>
        <Heading level={3} color='normal' fontWeight='bold'>
          Achados no exame clínico
        </Heading>
      </Cell>
      <Cell size={12}>
        <MamografiaIndicacaoClinicaMamaAccordion
          uuid='mamaDireita'
          title='Mama direita'
          names={{
            lesaoPapilar: MamografiaPerguntaField.lesaoPapilarDireita,
            descargaPapilar: MamografiaPerguntaField.descargaPapilarDireita,
            noduloLocalizacao: MamografiaPerguntaField.noduloLocalizacaoDireita,
            espessamentoLocalizacao: MamografiaPerguntaField.espessamentoLocalizacaoDireita,
            linfonodoPalpavel: MamografiaPerguntaField.linfonodoPalpavelDireita,
          }}
        />
      </Cell>
      <Cell size={12}>
        <MamografiaIndicacaoClinicaMamaAccordion
          uuid='mamaEsquerda'
          title='Mama esquerda'
          names={{
            lesaoPapilar: MamografiaPerguntaField.lesaoPapilarEsquerda,
            descargaPapilar: MamografiaPerguntaField.descargaPapilarEsquerda,
            noduloLocalizacao: MamografiaPerguntaField.noduloLocalizacaoEsquerda,
            espessamentoLocalizacao: MamografiaPerguntaField.espessamentoMamaEsquerda,
            linfonodoPalpavel: MamografiaPerguntaField.linfonodoPalpavelEsquerda,
          }}
        />
      </Cell>
      <Cell size={12}>
        <MamografiaIndicacaoClinicaAccordion
          uuid='controleRadio'
          options={controleRadioAccordionOptions}
          title='Controle radiológico Categoria BI RADS 3'
        />
      </Cell>
      <Cell size={12}>
        <MamografiaIndicacaoClinicaAccordion
          uuid='lesaoCancer'
          options={lesaoCancerAccordionOptions}
          title='Lesão com diagnostico de câncer'
        />
      </Cell>
      <Cell size={12}>
        <RadioGroupField
          name={MamografiaPerguntaField.avaliacaoRespostaQuimioterapia}
          label='Avaliação da resposta de quimioterapia neoadjuvante'
          options={avaliacaoRespostaQuimioterapiaOptions}
          clearable
        />
      </Cell>
      <Cell size={12}>
        <MamografiaIndicacaoClinicaAccordion
          uuid='revisaoMamografiaLesao'
          options={revisaoMamografiaLesaoAccordionOptions}
          title='Revisão de mamografia com lesão, realizada em outra instituição'
        />
      </Cell>
      <Cell size={12}>
        <MamografiaIndicacaoClinicaAccordion
          uuid='lesaoBenigna'
          options={lesaoBenignaAccordionOptions}
          title='Controle de lesão após biopsia de fragmento ou PAAF com resultado benigno'
        />
      </Cell>
    </Grid>
  )
}
